import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/authentication/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private permissionMap = new Map<string, any>();
  private isPermissionLoadingSubject = new BehaviorSubject<boolean>(false);
  public isPermissionLoading$ = this.isPermissionLoadingSubject.asObservable();
  private loaded = false;

  constructor(private http: HttpClient, private authService: AuthService) {}

  get isPermissionLoading(): boolean {
    return this.isPermissionLoadingSubject.value;
  }

  get isLoaded(): boolean {
    return this.loaded;
  }

  hasAnyPermission(): boolean {
    return this.permissionMap.size > 0;
  }

  loadPermissions(): Observable<any> {
    if (this.loaded) {
      return of(this.permissionMap);
    }
    
    const sessionDetails = this.authService.getSessionDetail();
    const userId = sessionDetails?.user?.user_id || sessionDetails?.user_id;
    const orgId = this.authService.getId();
    
    if (!userId || !orgId) {
      return of(null);
    }

    this.isPermissionLoadingSubject.next(true);

    const ssoApiUrl = environment.ssoApiUrl.replace(/\/$/, '');
    return this.http.get<any>(`${ssoApiUrl}/rbac/user-roles?user_id=${userId}&org_id=${orgId}&product_id=2`).pipe(
      tap((res) => {
        const permissions = res?.data?.permissions || [];
        console.log('TradeNext Permissions Loaded (product_id=2):', permissions);
        this.permissionMap.clear();
        permissions.forEach((p: any) => {
          this.permissionMap.set(p.code, p);
        });
        this.loaded = true;
        this.isPermissionLoadingSubject.next(false);
      }),
      catchError((error) => {
        console.error('Failed to load permissions', error);
        this.isPermissionLoadingSubject.next(false);
        return of(null);
      })
    );
  }

  hasAccess(code: string, requiredAccess: number = 100): boolean {
    const permission = this.permissionMap.get(code);
    if (!permission) return false;

    const level = permission.permission_code;
    if (level === 103) return true;   // Full Access
    if (level === 102) return false;  // No Access
    if (level === requiredAccess) return true;

    return level >= requiredAccess;
  }
}
